// extracted by mini-css-extract-plugin
export default {"content":"style_content__lbuTU","form":"style_form__TW+uG"};